<modal [tagEventImp]="tagEventImp" [tagEventClose]="tagEventClose">
    @if (isExpiredCart) {
        <p>Cette offre est une exclusivité partenaire.</p>
        <p>Malheureusement votre panier à expiré</p>
        <p>Rendez vous chez votre partenaire bancaire pour rééssayer</p>
    } @else {
        <p>Cette offre est une exclusivité partenaire.</p>
        <p>Rendez-vous sur {{ partner }} pour en profiter</p>
    }
    <p>
        ou
        <a class="link" (click)="goToWall()">consulter les forfaits mobiles Bouygues Telecom</a>
    </p>
</modal>
